export default ['pdf', 'jpg', 'png'];
